import React from 'react';
import cx from 'classnames';

import styles from './FormGroup.module.scss';

interface FormGroupProps {
  children: React.ReactNode;
  isSubmit?: boolean;
  'data-test'?: string;
  isNoMargin?: boolean;
  className?: string;
}

export const FormGroup: React.FC<FormGroupProps> = ({
  children,
  isSubmit,
  isNoMargin,
  className,
  ...props
}) => {
  return (
    <div
      className={cx(
        styles['form-group'],
        className,
        isSubmit && styles['form-group--submit'],
        isNoMargin && styles['form-group--no-margin'],
      )}
      data-test={props['data-test']}
    >
      {children}
    </div>
  );
};
